import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { TooltipTaxesBreakdownComponent } from './tooltip-taxes-breakdown.component';
import { UsbCarouselModule } from '../components/usb-carousel/usb-carousel.module';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    UsbCarouselModule
  ],
  declarations: [
    TooltipTaxesBreakdownComponent
  ],
  exports: [
    TooltipTaxesBreakdownComponent
  ]
})
export class TooltipTaxesBreakdownModule { }
